export default {
    mapId: 0, // 地图ID stage_0.tmx
    minLine: 0, // 当前关卡过关行数
    minStep: 0, // 当前关卡过关步数
    curLevelText: '', // 当前关卡文字, 如 : 1/20
    maskBox: false,
    adoptDialog: false,
    failDialog: false,
    failDialogChina: false,
    exitGameMode: false,
    adoptChinaDialog: false,
    adoptTitle: '',
    adoptText: '',
    failTitle: '',
    failText: '',
    ideMask: false,
    isLoading: false,
    imagesLoaded: false,
    loadingText: '',
    codeIndexDialog: false,
    checkpointShow: false, //关卡
    selectedPoint: '', //选中当前关卡
    funArr: [],
    funVisibleArr: [], // 可见的动作列表
    funIndex: 0, // 当前所在的动作列表的索引（点击向左-1， 点击向右+1）
    funShowCount: 0, // 显示的动作列表的个数
    checkpointData: [], //关卡信息
    explainDialog: false, //功能说明弹窗
    explainDialog1: false,
    explainDialog2: false,
    toBack: false,
    menuFlag: false, //菜单节流阀
    knowledgeArr: [], //知识点说明
    CommandList: [], //游戏说明
    StoryIntroList: [],
    CommentImgList: true, //注释图片展示
    imagePath: "",
    sessionShow: false,
    videoShow: false,
    checkLangShow: false,
    skipShow: false,
    currentIndex: false, //当前所在的位置
    highCheckShow: false,
    imgShow: false,
    isLastLevel: false, //判断是否是最后一关
    justLastLevel:false,
    skipStyleShow: true,
    skipNextShow: false,
    browserVersionShow: false,
    passAllLevelShow: false,
    interfaceErrorShow: false,
    audioShow: false,
    ipShow:false,
    times:0,
    competeType:0,
    edition:0,//0 入门组 1 初级组 3 中级组 2 高级组
    isVip:0,// 0 非vip 1 vip
    timeoverShow:false,
    imgList: [],
    dirLang: 'ltr',
    fullName: "",
    level: '',
    lang: "en",
    allStar: 0,
    configLine: 0,
    configSteps: 0,
    curLine: 0,
    curSteps: 0,
    star: 0,
    userLastName: "",
    userFirstName: "",
    isPassAllLevel: 0,
    currentLevel: "",
    qrCodeUrl: "",
    qrCodeShow: false,
    qrCodeShow2: false,
    codeShow: false,
    chooseMode: undefined,
    userType: 0, // 用户类型，1-学生， 2-教师
    getQRcode: "",
    blocklyShow:false,
    checkLangDialogShow:false,
    checkLangs:"en",
    blocklyText:{},
    Workspace:{},
    maxHighlevel:'',
    xml_text:'',
    blockly_json: '',
    blPython:'',
    gameId:"",
    courseTitleTxt:"",  // 课程名称
    timeText:"00:00",
    monthlyGameShow:false,
    loadingTimeShow:true,
    totalScore:0,
    tourCompelete:false,
    tourNotCompelete:false,
    tourCompeleteNotGet:false,
    tourGameNotPass:false,
    pathAllImage:"",
    allArr: [
        { id: 20, describe: 'step', img: process.env.IMG_BASE_URL + 'mars_step.png', code: '.step()', tips: 'step' },
        { id: 21, describe: 'turnLeft', img: process.env.IMG_BASE_URL + 'mars_turnLeft.png', code: '.turnLeft()', tips: 'turnLeft' },
        { id: 22, describe: 'turnRight', img: process.env.IMG_BASE_URL + 'mars_turnRight.png', code: '.turnRight()', tips: 'turnRight' },
        { id: 25, describe: 'for', img: process.env.IMG_BASE_URL + 'mars_for.png', code: 'for i in range():', tips: 'for' },
        { id: 27, describe: 'distanceTo', img: process.env.IMG_BASE_URL + 'mars_distanceTo.png', code: '.distanceTo()', tips: 'distance' },
        { id: 30, describe: 'while', img: process.env.IMG_BASE_URL + 'mars_while.png', code: 'while', tips: 'while' },
        { id: 31, describe: 'turnTo', img: process.env.IMG_BASE_URL + 'mars_turnTo.png', code: '.turnTo()', tips: 'turnToOb' },
        { id: 32, describe: 'chase', img: process.env.IMG_BASE_URL + 'mars_chase.png', code: '.chase()', tips: 'chase' },
        { id: 33, describe: 'function', img: process.env.IMG_BASE_URL + 'mars_function.png', code: 'def', tips: 'def' },
        { id: 35, describe: 'if', img: process.env.IMG_BASE_URL + 'mars_if.png', code: 'if', tips: 'if' },
        { id: 36, describe: 'if_else', img: process.env.IMG_BASE_URL + 'mars_ifelse.png', code: 'if \n' + '\n' + 'else ', tips: 'if_else' },
        { id: 38, describe: 'wait', img: process.env.IMG_BASE_URL + 'mars_wait.png', code: 'wait()', tips: 'wait' },
        { id: 39, describe: 'for', img: process.env.IMG_BASE_URL + 'mars_for.png', code: 'for en in Energy:', tips: 'for_in' },
        { id: 40, describe: 'onClick', img: process.env.IMG_BASE_URL + 'mars_onClick.png', code: 'onClick()', tips: 'onClick' },
        { id: 41, describe: 'onTouch', img: process.env.IMG_BASE_URL + 'mars_onTouch.png', code: 'onTouch(pos):', tips: 'onTouch' },
        { id: 42, describe: 'mover', img: process.env.IMG_BASE_URL + 'mars_goto.png', code: 'mover.', tips: 'mover' },
        { id: 43, describe: 'power', img: process.env.IMG_BASE_URL + 'mars_health.png', code: '.energy', tips: 'energy' },
        { id: 45, describe: 'broken', img: process.env.IMG_BASE_URL + 'mars_broken.png', code: '.broken()', tips: 'broken' },
        { id: 46, describe: 'goNrsSolar', img: process.env.IMG_BASE_URL + 'mars_goNearesSolar.png', code: 'goNearesSolar( )', tips: 'goNearesSolar' },
        { id: 48, describe: 'return', img: process.env.IMG_BASE_URL + 'mars_return.png', code: 'return', tips: 'return' },
        { id: 50, describe: 'goodH', img: process.env.IMG_BASE_URL + 'mars_goodHealth.png', code: 'goodHealth()', tips: 'goodHealth' },
        { id: 51, describe: 'badH', img: process.env.IMG_BASE_URL + 'mars_badHealth.png', code: 'badHealth()', tips: 'badHealth' },
        { id: 53, describe: 'disappear', img: process.env.IMG_BASE_URL + 'mars_disapper.png', code: '.disappear()', tips: 'disappear' },
        { id: 56, describe: 'clickQiQi', img: process.env.IMG_BASE_URL + 'mars_clickQiQi.png', code: 'clickQiQi()', tips: 'clickQiQi' },
        { id: 57, describe: 'clickAirship', img: process.env.IMG_BASE_URL + 'mars_clickAirship.png', code: 'clickAirship()', tips: 'clickAirship' },
        { id: 58, describe: 'clickEnergy', img: process.env.IMG_BASE_URL + 'mars_clickEnergy.png', code: 'clickEnergy()', tips: 'clickEnergy' },
        { id: 59, describe: 'clickFlyer', img: process.env.IMG_BASE_URL + 'mars_clickFlyer.png', code: 'clickFlyer()', tips: 'clickFlyer' },
    ],
    // 图片管理
    allImageMap: {
        'icon1': process.env.IMG_BASE_URL + 'icon1.png',
        'icon2': process.env.IMG_BASE_URL + 'icon1.png',
        'icon3': process.env.IMG_BASE_URL + 'icon2.png',
        'icon4': process.env.IMG_BASE_URL + 'icon2.png',
        'icon5': process.env.IMG_BASE_URL + 'icon2.png',
        'icon6': process.env.IMG_BASE_URL + 'icon2.png',
        'icon7': process.env.IMG_BASE_URL + 'icon3.png',
        'icon8': process.env.IMG_BASE_URL + 'icon3.png',
        'icon9': process.env.IMG_BASE_URL + 'icon5.png',
        'icon10': process.env.IMG_BASE_URL + 'icon5.png',
        'icon11': process.env.IMG_BASE_URL + 'icon5.png',
        'icon12': process.env.IMG_BASE_URL + 'icon4.png',
        'icon13': process.env.IMG_BASE_URL + 'icon4.png',
        'icon14': process.env.IMG_BASE_URL + 'icon10.png',
        'icon15': process.env.IMG_BASE_URL + 'icon10.png',
    },
    allBgMap: [
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit01.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit02.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit03.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit04.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit05.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit06.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit07.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit08.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit09.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit10.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit11.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit12.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit13.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit14.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit15.png' },

    ],
    GameConfig: null,
};


// WEBPACK FOOTER //
// ./src/store/state.js